export const dialogID = 'status-dialog';
